import SymptomInput from "../Main/SymptomsInput";

const AdultSymptom = () => {
    return <SymptomInput whichOne={'Adult'} />;
  };
  
  export default AdultSymptom;
  
